import { YaraTestRunGridData, YaraTestRunGridItem } from "./yaratestrunstate";

export type YaraTestRunGridProps = {
  isLoading: boolean;
  status?: number;
  message?: string;
  data: YaraTestRunGridData | undefined;
  onResultClick?: (hash: string, resultId: number) => void;
};

interface ISchemaField {
  name: string;
  displayTitle: string | JSX.Element;
  sortable?: boolean;
  className?: string;
  component: (
    data: YaraTestRunGridItem,
    index?: number
  ) => null | number | string | JSX.Element;
  style: Record<string, string>;
}

export interface ISchema {
  fields: Array<ISchemaField>;
}
